import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';

import { CSSTransition, TransitionGroup } from 'react-transition-group';

import Home from '../pages/Home';
import About from '../pages/About';
import Contact from '../pages/Contact';

const Routes: React.FC = () => {
  const location = useLocation();

  return (
    <TransitionGroup>
      <CSSTransition key={location.key} timeout={500} classNames="fade">
        <Switch location={location}>
          <Route path="/" exact component={Home} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default Routes;
